export default __webpack_public_path__ + "static/media/archywavedubai.59e839df.webp";